var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCentralizeRecordingSelect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_160157",
    "data-name": "Group 160157",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.461,
    height: 13.552,
    viewBox: "0 0 13.461 13.552",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37812",
    "data-name": "Path 37812",
    d: "M11.5,3.858H1.929A1.929,1.929,0,1,1,1.929,0H11.5a1.929,1.929,0,1,1,0,3.858M1.929.678a1.251,1.251,0,1,0,0,2.5H11.5a1.251,1.251,0,1,0,0-2.5Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37813",
    "data-name": "Path 37813",
    d: "M6.645,3.023H2.613a.339.339,0,0,1,0-.678H6.645a.339.339,0,1,1,0,.678",
    transform: "translate(-0.732 -0.754)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37814",
    "data-name": "Path 37814",
    d: "M16.651,3.108a.627.627,0,0,1-.2-.034.681.681,0,0,1-.163-.109.536.536,0,0,1-.149-.366.479.479,0,0,1,.041-.19.545.545,0,0,1,.109-.17.511.511,0,0,1,.556-.109.515.515,0,0,1,.162.109.545.545,0,0,1,.109.17.48.48,0,0,1,.041.19.534.534,0,0,1-.15.366.664.664,0,0,1-.162.109.634.634,0,0,1-.2.034",
    transform: "translate(-5.195 -0.674)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37816",
    "data-name": "Path 37816",
    d: "M1.929,10.326a1.251,1.251,0,1,1,0-2.5H5.635a5.162,5.162,0,0,1,.894-.678h-4.6a1.929,1.929,0,1,0,0,3.858H4.047a5.2,5.2,0,0,1,.125-.678Z",
    transform: "translate(0 -2.299)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37817",
    "data-name": "Path 37817",
    d: "M2.612,9.49a.339.339,0,1,0,0,.678H5.224A5.181,5.181,0,0,1,5.6,9.49Z",
    transform: "translate(-0.732 -3.055)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37818",
    "data-name": "Path 37818",
    d: "M5.459,17.471H1.929a1.251,1.251,0,1,1,0-2.5h2.2a5.317,5.317,0,0,1-.095-.678h-2.1a1.929,1.929,0,1,0,0,3.858H6.254a5.194,5.194,0,0,1-.794-.678",
    transform: "translate(0 -4.6)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37819",
    "data-name": "Path 37819",
    d: "M2.612,16.636a.339.339,0,1,0,0,.678H5.493a5.043,5.043,0,0,1-.35-.678Z",
    transform: "translate(-0.732 -5.354)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160158",
    "data-name": "Group 160158"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37815",
    "data-name": "Path 37815",
    d: "M11.535,15.933A4.266,4.266,0,1,1,15.8,11.667a4.27,4.27,0,0,1-4.266,4.266m0-7.853a3.588,3.588,0,1,0,3.588,3.588,3.591,3.591,0,0,0-3.588-3.588",
    transform: "translate(-2.34 -2.381)",
    fill: "#e11e24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37820",
    "data-name": "Path 37820",
    d: "M15.368,12.344l-3.75-2.227a.217.217,0,0,0-.328.187v4.455a.217.217,0,0,0,.328.187l3.75-2.227a.217.217,0,0,0,0-.374",
    transform: "translate(-3.633 -3.246)",
    fill: "#e11e24"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentralizeRecordingSelect);
export default __webpack_public_path__ + "static/media/centralize-recording-select.1e08b344cabd42cfd37146e7c654b5d7.svg";
export { ForwardRef as ReactComponent };